import { useEffect } from "react";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import promoVideo from "../../assets/images/Demo.mp4";
import {
  AdLabel,
  Card,
  CloseButton,
  CtaLink,
  FullCardLink,
  Header,
  Overlay,
  Subtitle,
  TextLayer,
  Title,
  Video,
} from "./LandingPromoPopup.styles";

const PLAYBOX_URL = "https://www.playbox.com";

const LandingPromoPopup = ({ isOpen, onClose }) => {
  useLockBodyScroll(isOpen);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <Overlay onMouseDown={onClose}>
      <Card
        role="dialog"
        aria-modal="true"
        aria-label="Turn any photo into video"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <Video
          src={promoVideo}
          aria-hidden="true"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
        />
        <FullCardLink
          href={PLAYBOX_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open photo to video offer"
          onClick={onClose}
        />
        <TextLayer>
          <Header>
            <AdLabel>AD</AdLabel>
            <CloseButton
              type="button"
              aria-label="Close photo to video popup"
              onClick={onClose}
            />
          </Header>
          <Title>Turn Any Photo Into Video</Title>
          <Subtitle>Upload a photo • Get a video</Subtitle>
        </TextLayer>
        <CtaLink
          href={PLAYBOX_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Try photo to video free now"
          onClick={onClose}
        >
          TRY FREE NOW
        </CtaLink>
      </Card>
    </Overlay>
  );
};

export default LandingPromoPopup;
